'use client';
import PropTypes from 'prop-types';
import { Tips } from '../Tips';
import { DidYouKnowCard } from '../DidYouKnowCard';
import {
  StyledScreeningStepContainer,
  StyledStepContentContainer,
} from './styles';

export const ScreeningStepContainer = ({ didYouKnowInfo, tips, children }) => (
  <StyledScreeningStepContainer>
    <StyledStepContentContainer>{children}</StyledStepContentContainer>
    {Boolean(tips?.cards?.length) && <Tips {...tips} />}
    <DidYouKnowCard {...didYouKnowInfo} />
  </StyledScreeningStepContainer>
);

ScreeningStepContainer.displayName = 'ScreeningStepContainer';
ScreeningStepContainer.propTypes = {
  didYouKnowInfo: PropTypes.object,
  tips: PropTypes.shape({
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        content: PropTypes.string,
        icon: PropTypes.object,
      }),
    ),
    title: PropTypes.string,
  }),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
